/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Loader } from "@mantine/core";
import cx from "clsx";
const BoxLoader = ({ className }: any) => {
  return (
    <Box className={cx("wrap-box-loader", className)} pos={"absolute"}>
      <Box pos={"absolute"} className="box-loader">
        <Loader className="loading-icon" size={"md"} type="dots" />
      </Box>
    </Box>
  );
};
export default BoxLoader;
